var version = {
    "name":      "dativery",
    "buildDateCode": "20260901-103334",
    "buildDate": "Tue Sep 01 2026 10:33:34 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260901-103334",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;